import { WcStack } from "@bpipartners/webui";
import React from "react";
import { BreadCrumbs, BreadCrumbsProps } from "@guberno/ui";
import { useTheme } from "@guberno/utils/theme";

interface BreadcrumbOnlySubHeaderProps {
  height?: string | number;
  breadcrumbsProps?: BreadCrumbsProps;
  children?: React.ReactNode;
}

export const BreadcrumbOnlySubHeader = ({
  breadcrumbsProps,
  children,
}: BreadcrumbOnlySubHeaderProps) => (
  <WcStack id="BreadcrumbOnlySubHeader" width={"100%"}>
    {breadcrumbsProps && <BreadCrumbs {...breadcrumbsProps} />}
    {children && <>{children}</>}
  </WcStack>
);

export default BreadcrumbOnlySubHeader;
